
function ErrorComponent() {
  // STATES //


  return (<h1></h1>);
}
export default ErrorComponent;
